import { useGetAccounts } from "hooks/useAccounts";
import { useEffect, useState } from "react";
import * as i18n from "util/i18n";

export const types = { CA: "savings", CC: "checking", CBB: "CBB" };

export const useEcheckAccountSelector = (currency, accountType) => {
    const { accounts, fetching } = useGetAccounts("", "", "", true);
    const [accountOptions, setAccountOptions] = useState([]);

    const handleSelectorOptions = () => {
        const options = accounts.filter(
            (account) => account.currency === currency && account.accountType === accountType,
        );
        setAccountOptions(
            options.map((account) => ({
                balance: { currency: account?.currency, quantity: account?.availableBalance },
                currency: account?.currency,
                frequentDestination: null,
                id: account?.productId,
                label: `${i18n.get(`productType.${account?.accountType}`)} ····${account?.accountNumber?.slice(-4)}`,
                minimumPayment: 0,
                permissions: Object.keys(account?.permissions),
                statementsLoan: null,
                totalPayment: 0,
                type: account?.accountType,
            })),
        );
    };

    useEffect(() => {
        if (accounts.length !== 0) {
            handleSelectorOptions();
        }
    }, [accounts]);

    return {
        accountOptions,
        accounts,
        fetching,
    };
};

export default useEcheckAccountSelector;
